import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Preloader from "components/Common/Loader"
import CommodityClassificationForm from "components/CommodityClassification/form"
import {
  getByIdCommodityClassification,
  updateCommodityClassification,
} from "store/commodity-classification/commodity-classification-action"
import { commodityClassificationAction } from "store/commodity-classification/commodity-classification-slice"

const EditCommodityClassification = () => {
  document.title = "Edit Unit Classification"
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, commodityClassification, error } = useSelector(
    state => state.commodityClassification
  )

  useEffect(() => {
    dispatch(getByIdCommodityClassification(id))

    return () => {
      dispatch(commodityClassificationAction.resetState())
    }
  }, [dispatch, id])

  if (!commodityClassification) {
    return <Preloader loading={true} />
  }

  return (
    <CommodityClassificationForm
      loading={loading}
      commodityClassification={commodityClassification?.data}
      error={error}
      onSubmit={values =>
        dispatch(updateCommodityClassification(id, values, navigate))
      }
      formMode={"Edit"}
    />
  )
}

export default EditCommodityClassification
